import { DataList, Modal, TableFilter } from '@welbe/web-design-system';
import labs from 'App/assets/callToActionExams/labs.png';
import { ReactComponent as Heart } from 'App/assets/img/heart-white.svg';
import { useWindowSize } from 'hooks/useWindowSize';
import { useState } from 'react';
import { formattedRows } from './Builder';
import { useContent } from './Content.hooks';
import {
	Container,
	ExamAlert,
	ExamAlertText,
	ExamsAlertContainer,
	LayoutPage,
	Separator,
} from './Content.styles';
import { CandidatesFilters } from './components/CandidatesFilters/CandidatesFilters';
import { ExamsPreview } from './components/ExamsPreview/ExamsPreview';

interface ContentProps {
	onSelect: (e: any) => void;
	selectedCandidates: any;
	onUpdateTable: boolean;
}

export const Content = ({
	onSelect,
	selectedCandidates,
	onUpdateTable,
}: ContentProps): JSX.Element => {
	const { height } = useWindowSize();

	const {
		isFilterOpen,
		showBusinessNames,
		isProfileButtonVisible,
		getDataListColumns,
		setFilterOpen,
		handleOpenChat,
		handleOpenCandidate,
		data,
		loading,
		totalPages,
		currentPage,
		handleSearch,
		handleFilters,
		handleChangePage,
		filters,
	} = useContent({ onUpdateTable });

	const [candidateResults, setCandidateResults] = useState<any>(null);
	const handleShowResults = (candidate: any) => {
		setCandidateResults({
			id: candidate.id,
			name: candidate.name,
			exams: candidate.exams,
		});
	};

	return (
		<>
			{!isProfileButtonVisible && (
				<ExamsAlertContainer>
					<ExamAlert>
						<img src={labs} alt="labs" />
						<ExamAlertText>
							<p>
								Agiliza y complementa las valoraciones médicas de tus candidatos
								con exámenes de laboratorio
							</p>
							<p>
								Reduce el tiempo de los procesos de contratación de tu empresa y
								disminuye los riesgos al contratar con el módulo de candidatos
								<button onClick={handleOpenChat}>Más información</button>
							</p>
						</ExamAlertText>
					</ExamAlert>
					<Separator />
				</ExamsAlertContainer>
			)}

			{candidateResults?.id && (
				<Modal
					open
					preventBackdropClose
					width="836px"
					padding="24px"
					headerIcon={<Heart className="exam-preview-header-icon" />}
				>
					<ExamsPreview
						name={candidateResults?.name}
						exams={candidateResults?.exams}
						onClose={() => setCandidateResults(null)}
					/>
				</Modal>
			)}

			<Container>
				<TableFilter
					open={isFilterOpen}
					height={height - 300}
					filters={filters}
					onSearch={handleSearch}
					onClose={() => setFilterOpen(false)}
					onOpen={() => setFilterOpen(true)}
				>
					<CandidatesFilters
						height={height - 210}
						showBusinessNames={showBusinessNames}
						onChangeFilters={handleFilters}
						onSearch={handleSearch}
					/>
				</TableFilter>
				<LayoutPage>
					<DataList
						onSelect={onSelect}
						selected={selectedCandidates}
						loading={loading}
						headers={getDataListColumns()}
						currentPage={currentPage}
						pagesNumber={totalPages}
						onChangePage={handleChangePage}
						rows={formattedRows(data, handleOpenCandidate, handleShowResults)}
						height={`${height - 300}px`}
					/>
				</LayoutPage>
			</Container>
		</>
	);
};
